import { ReactNode } from 'react';
import { BodyText } from '@/common/components/BodyText/BodyText';
import { Button, IButtonProps } from '@/common/components/Button/Button';
import { Stack } from '@/common/components/Stack/Stack';
import { styles } from './EmptyState.styles';

interface IEmptyStateProps {
  title: string;
  description: string;
  ilustration: ReactNode;
  primaryButtonProps?: Omit<IButtonProps, 'variant'>;
}

export function EmptyState({
  title,
  description,
  ilustration,
  primaryButtonProps,
}: IEmptyStateProps) {
  return (
    <Stack align="center" gap="md" className={styles.container}>
      {ilustration}
      <Stack align="center">
        <BodyText className={styles.text} bold>
          {title}
        </BodyText>
        <BodyText size="sm" color="neutral20" className={styles.text}>
          {description}
        </BodyText>
      </Stack>
      {primaryButtonProps && <Button {...primaryButtonProps} />}
    </Stack>
  );
}
